import React from 'react';
import PropTypes from 'prop-types';
import TitleDetail from './TitleDetail';
import DrawerAnchor from '../UI/DrawerAnchor';
import { withIsMobile } from 'treeline-react-core-components/WindowSizeProvider';
import LoadingSpinnerInContainer from '../UI/LoadingSpinnerInContainer';
import './titleDetailDrawer.less';
import { LoadingSpinnerSize } from '../UI/LoadingSpinner';

export class TitleDetailDrawer extends React.Component {
	static propTypes = {
		sku: PropTypes.string,
		children: PropTypes.oneOfType([
			PropTypes.func,
			PropTypes.element,
			PropTypes.string,
		]),
		parentStyle: PropTypes.string,
		// Mapped to props
		isMobile: PropTypes.func,
		isDataFetching: PropTypes.bool,
	};

	static defaultProps = {
		parentStyle: 'clickable dotDot',
		isDataFetching: false,
	};

	render() {
		const { children, parentStyle } = this.props;
		const isMobile = this.props.isMobile();
		return (
			<DrawerAnchor
				closable={true}
				width={isMobile ? '100%' : '90%'}
				placement={isMobile ? 'bottom' : 'left'}
				height={isMobile ? '90%' : '100%'}
				parentStyle={parentStyle}
				renderDrawerContent={this.renderDrawerContent}
				drawerClassName="title-detail-drawer">
				{children}
			</DrawerAnchor>
		);
	}

	renderDrawerContent = drawer => {
		return drawer.isVisible && this.renderTitleDetail();
	};

	renderTitleDetail = () => {
		const { sku, communityId, isDataFetching } = this.props;
		return isDataFetching ? (
			<LoadingSpinnerInContainer
				height="100%"
				size={LoadingSpinnerSize.large}
			/>
		) : (
			<TitleDetail sku={sku} communityId={communityId} />
		);
	};
}

export default withIsMobile(TitleDetailDrawer);
